export default __webpack_public_path__ + "static/media/cage_2.4c89cbb1.svg";